import { Component, Inject } from '@angular/core';

import { UploadColumn } from 'app/providers/storage-api/upload.service';

import { MatDialogRef, MAT_DIALOG_DATA } from 'app/services/dialog.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

export interface TxEditorDialogOptions {
  column: UploadColumn;
  isGroupby: boolean;
}

@EnableClassTelemetry()
@Component({
  selector: 'app-tx-editor-dialog',
  templateUrl: './tx-editor-dialog.component.html',
  styleUrls: ['./tx-editor-dialog.component.scss'],
  standalone: false,
})
export class TxEditorDialogComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  public transform: string;
  public groupbyCheckbox;

  constructor(
    private dialogRef: MatDialogRef<TxEditorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private options: TxEditorDialogOptions
  ) {
    this.transform = options.column.transform || '';
    this.groupbyCheckbox = options.isGroupby;
  }

  public close(): void {
    this.dialogRef.close();
  }

  public async confirm(): Promise<void> {
    const result = {
      transform: this.transform,
      isGroupby: this.groupbyCheckbox,
    };

    this.dialogRef.close(result);
  }
}
